import React from 'react';
import { HeartIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function TestimonialsSection() {
  return <section className="w-full bg-ink-950 py-20" aria-labelledby="testimonios" data-id="element-163" data-mp="20qxh5n2fr6z1">
      <div className="mx-auto w-full max-w-6xl px-4 sm:px-6" data-id="element-164" data-mp="1myz97fkgnh4g">
        <h2 id="testimonios" className="flex items-center gap-3 font-display text-3xl font-900 leading-tight text-white sm:text-4xl" style={{
        fontSize: "28px"
      }} data-id="element-165" data-mp="1r1due6blqsyw">
          <HeartIcon className="h-6 w-6 flex-none text-gold" aria-hidden="true" data-id="element-166" data-mp="1d47eqkm6dadw" />
          Familias de España y Latinoamérica que ya tomaron el control
        </h2>

        <ul className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-167" data-mp="142hld98qg1dh">
          {testimonials.map(item => <li key={item.name} className="flex flex-col rounded-xl border border-ink-800 bg-ink-900 p-6" data-id="element-168" data-mp="183t5iz8u7uea">
              <p className="text-xs tracking-widest text-gold" aria-label="5 de 5 estrellas" data-id="element-169" data-mp="2ygimy1vo32h9">
                ★★★★★
              </p>
              <p className="mt-3 text-[15px] leading-relaxed text-slate-200" data-id="element-170" data-mp="32eomopy38hso">“{item.quote}”</p>
              <p className="mt-auto flex items-center gap-2.5 pt-5 text-sm text-slate-400" data-id="element-171" data-mp="2uzhs1cger2du">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-ink-700 font-display text-xs font-700 text-gold" data-id="element-172" data-mp="2q27vlculpqgi">
                  {item.initials}
                </span>
                <span data-id="element-173" data-mp="2zt2r77tqm2em">
                  <span className="block font-600 text-white" data-id="element-174" data-mp="2c2qc9d02r5ej">{item.name}</span>
                  {item.city}
                </span>
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}